import { useMemo } from "react";
import { BLOCKS, MARKS } from "@contentful/rich-text-types";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { Title } from "../../atoms/Title/title";
import { Subtitle } from "../../atoms/Subtitle/subtitle";
import sanitizeHTML from "../../utils/sanitizeHtml";
import { isHTML } from "../../utils";
import "./styles.scss";

const Text = ({ children }) => <p className=""> {children} </p>;
const Heading4 = ({ children }) => (
  <Subtitle
    big
    strong
    content={children}
  />
);
const RichText = ({ customClass, content, siteData, withRenderText }) => {
  const internalContent = content && typeof content.raw === "object";

  const options = useMemo(() => {
    let opt = {
      renderMark: {
        [MARKS.BOLD]: (text) => {
          return <b>{text}</b>;
        },
        [MARKS.CODE]: (code) => {
          let contPara = "";

          if (siteData[code]) {
            contPara = siteData[code];
          } else if (isHTML(code)) {
            contPara = code;
          }

          if (typeof contPara === "string" && contPara.length > 0) {
            return <span dangerouslySetInnerHTML={{ __html: sanitizeHTML(contPara) }}></span>;
          } else {
            return null;
          }
        },
      },
      renderNode: {
        [BLOCKS.EMBEDDED_ASSET]: (node) => {
          return (
            <div className="e-image--content">
              <img
                alt={`${node.data.target.fields.title["en-US"]}`}
                className="e-image"
                src={`${node.data.target.fields.file["en-US"].url}`}
              />
            </div>
          );
        },
        [BLOCKS.PARAGRAPH]: (node, children) => {
          return <Text>{children}</Text>;
        },
        [BLOCKS.HEADING_4]: (node, children) => {
          return <Heading4>{children}</Heading4>;
        },
        [BLOCKS.UL_LIST]: (node, children, a) => {
          return <ul className="e-list">{children}</ul>;
        },
        [BLOCKS.HEADING_5]: (node, children) => {
          return (
            <div className="r-alert">
              <p>{children}</p>
            </div>
          );
        },
        [BLOCKS.HEADING_6]: (node, children) => {
          return (
            <Title
              grand
              content={children}
            />
          );
        },
        [BLOCKS.QUOTE]: (node, children) => {
          return (
            <div className="m-blockquote">
              <p>{children}</p>
            </div>
          );
        },
        [BLOCKS.EMBEDDED_ENTRY]: (node) => {
          return (
            <div
              dangerouslySetInnerHTML={{
                __html: sanitizeHTML(node.data.target.childContentfulTablesTableTextNode.table),
              }}
            />
          );
        },
      },
    };

    if (withRenderText) {
      opt.renderText = (text) => {
        if (text.includes("<table") && text.includes("</table>")) {
          return (
            <div
              style={{ display: "inline-block" }}
              dangerouslySetInnerHTML={{ __html: text }}></div>
          );
        } else {
          return text;
        }
      };
    }

    return opt;
  }, [withRenderText, siteData]);

  if (internalContent) {
    const stringifiedContent = { raw: JSON.stringify(content.raw) };
    return (
      <div className={`richText ${customClass}`}>
        {content && renderRichText(stringifiedContent, options)}
      </div>
    );
  }

  return (
    <div className={`richText ${customClass}`}>{content && renderRichText(content, options)}</div>
  );
};

export default RichText;
